import { ValidationRule } from './types';

const rules: ValidationRule[] = [];

export const registerRule = (rule: ValidationRule): void => {
  if (rules.some(r => r.id === rule.id)) {
    console.warn(`[validation] Rule ${rule.id} already registered; overwriting.`);
    const idx = rules.findIndex(r => r.id === rule.id);
    rules[idx] = rule;
    return;
  }
  rules.push(rule);
};

export const getRules = (): ReadonlyArray<ValidationRule> => rules;

export const getRule = (id: string): ValidationRule | undefined =>
  rules.find(r => r.id === id);
